__turbopack_context__.v({
  "forgotPassword": "login-form-module__Fkv70a__forgotPassword",
  "formBody": "login-form-module__Fkv70a__formBody",
  "formDivider": "login-form-module__Fkv70a__formDivider",
  "formDividerText": "login-form-module__Fkv70a__formDividerText",
  "formField": "login-form-module__Fkv70a__formField",
  "formInput": "login-form-module__Fkv70a__formInput",
  "formInputs": "login-form-module__Fkv70a__formInputs",
  "formSubtitle": "login-form-module__Fkv70a__formSubtitle",
  "formTitle": "login-form-module__Fkv70a__formTitle",
  "formTitleHeading": "login-form-module__Fkv70a__formTitleHeading",
  "loginBtn": "login-form-module__Fkv70a__loginBtn",
  "loginForm": "login-form-module__Fkv70a__loginForm",
  "loginSso": "login-form-module__Fkv70a__loginSso",
  "serverError": "login-form-module__Fkv70a__serverError",
});
